import { usePermissions } from "./hooks/usePermissions";

export const Features: {
  [category: string]: string;
} = {
  CASE_ANALYSIS: "cases:analysis",
  M365_ADMIN: "m365:admin",
  GOOGLE_WORKSPACE_ADMIN: "google:admin",
  EVIDENCE_BULK_COC_ALL: "evidence:bulk-coc-all", // This enables bulk coc actions from the master evidence table.
};

export enum FeatureFlags {
  CASE_ANALYSIS = "cases:analysis",
  M365_ADMIN = "m365:admin",
  GOOGLE_WORKSPACE_ADMIN = "google:admin",
  EVIDENCE_BULK_COC_ALL = "evidence:bulk-coc-all", // This enables bulk coc actions from the master evidence table.
}

const allowedDomains: {
  [feature: string]: string[];
} = {
  [Features.CASE_ANALYSIS]: [
    "accenture.com",
    "kyndryl.com",
    "bannerhealth.com",
    "summitforensics.com",
    "mtahq.org",
    "desjardins.com",
    "carle.com",
    "frsecure.com",
    "datto.com",
    "kaseya.com",
    "cyxcel.com",
    "cybervance.com",
    "ornl.gov",
    "mjolnirsecurity.com",
    "monolith_test",
    "tenant_bkUqgHaPtGJA",
    "tenant_mgmAQnnJreGE",
    "tenant_nNstkRaxjFep",
    "tenant_1MrLFaYhsFz6",
    "tenant_qCHT1pb1dDmy",
    "tenant_pcK2oDtFsSjr",
    "tenant_84NVvB8wNWaS",
    "tenant_78fWTxWze2wm",
    "tenant_4EJy3UZKxybS",
    "tenant_eRWe2eRMGJQc",
    "tenant_gEFwYo5LkKP3",
    "tenant_sCKRgCi7EZMo",
  ],
  [Features.GOOGLE_WORKSPACE_ADMIN]: [
    "tenant_v497k76FsBYo",
    "tenant_3df19a4d29c8",
    "monolith_test",
  ],
  [Features.EVIDENCE_BULK_COC_ALL]: ["_monolith_test"],
};

export const FeatureFlagResolver = (
  email: string,
  tenant: string,
  feature: string
): boolean => {
  if (!email.includes("@")) {
    console.error("Invalid tenant email address");
    return false;
  }
  if (!allowedDomains[feature]) {
    console.error(`Feature "${feature}" not found in allowed domains`);
    return false;
  }

  const domain = email.split("@")[1];

  return (
    allowedDomains[feature].includes(domain) ||
    allowedDomains[feature].includes(tenant)
  );
};

export const useFeatureFlagResolver = (feature_flag: FeatureFlags) => {
  const { currentUser, workspace } = usePermissions();
  return FeatureFlagResolver(
    currentUser.email,
    workspace.tenant_slug,
    feature_flag
  );
};
